import { JSX } from 'react';
import { FormattedMessage } from 'react-intl';

import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { H4 } from '@osmosis/tailwind-ui/components/Text';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';

/**
 * CopyLinkSnackBar.
 */
const CopyLinkSnackBar = ({ link }: { link?: string }): JSX.Element => {
  return (
    <Flex
      className="wrap-break-word items-start gap-2"
      data-testid="copy.link.container"
    >
      <Icon icon={faCircleCheck} size="lg" />
      <Box>
        <H4 className="text-white">
          <FormattedMessage
            id="copy.link.message"
            defaultMessage="Copied to clipboard"
          />
        </H4>
        <P className="text-white" data-testid="copy.link.pageLink">
          {link || window.location.href}
        </P>
      </Box>
    </Flex>
  );
};

export default CopyLinkSnackBar;
